module.exports = __webpack_public_path__ + "img/e.815e27dc.jpg";